import React from "react";
import { Tabs, Tab, Nav } from "react-bootstrap";

const OrderTabs = ({ curActive, handleSelect, totalOrders = 0 }) => {
    const StatusButton = ({ label, count, color }) => {
        return (
            <div
                className="d-flex flex-column align-items-center p-2 status-indicator"
                style={{
                    backgroundColor: color,
                    color: "white",
                    borderRadius: "5px",
                    width: "100px",
                }}
            >
                <h5>{count}</h5>
                <span>{label}</span>
            </div>
        );
    };
    return (
        <Tabs
            defaultActiveKey={curActive}
            id="status-indicators-tabs"
            activeKey={curActive}
            onSelect={handleSelect}
            className="mb-3"
        >
            <Tab eventKey="ALL" title="ALL">
                <StatusButton label="ALL" count={totalOrders} color="red" />
            </Tab>
            <Tab eventKey="pending" title="PENDING">
                <StatusButton label="PENDING" count={totalOrders} color="green" />
            </Tab>
            <Tab eventKey="confirmed" title="CONFIRMED">
                <StatusButton label="CONFIRMED" count={totalOrders} color="orange" />
            </Tab>
            <Tab eventKey="packed" title="PACKED">
                <StatusButton label="PACKED" count={totalOrders} color="blue" />
            </Tab>
            <Tab eventKey="shipped" title="SHIPPED">
                <StatusButton label="SHIPPED" count={totalOrders} color="teal" />
            </Tab>
            <Tab eventKey="delivered" title="DELIVERED">
                <StatusButton label="DELIVERED" count={totalOrders} color="purple" />
            </Tab>
            <Tab eventKey="cancelled" title="CANCELLED">
                <StatusButton label="CANCELLED" count={totalOrders} color="gray" />
            </Tab>
            <Nav.Link eventKey="deliconfirm" title="DELIVERY CONFIRMED">
                <StatusButton
                    label="DELIVERY CONFIRM"
                    count={totalOrders}
                    color="gray"
                />
            </Nav.Link>
        </Tabs>
    );
};

export default OrderTabs;